var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-element-studio-copyable"},[_c('textarea',{ref:"input",attrs:{"readonly":""},domProps:{"value":_vm.textToCopy}}),(_vm.shouldCopy)?_c('v-btn',{attrs:{"small":""},on:{"click":_vm.copy}},[_vm._v("Copy")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }